/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */

/**
 * Status
 */
export type GetPaginationExchangeTransactionsResponseDataItemStatus = typeof GetPaginationExchangeTransactionsResponseDataItemStatus[keyof typeof GetPaginationExchangeTransactionsResponseDataItemStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetPaginationExchangeTransactionsResponseDataItemStatus = {
  pending: 'pending',
  success: 'success',
  void: 'void',
} as const;
